import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/kenaikanpangkatService'
import ReportBloc from '../Blocs/ReportBloc'

class ReportModal extends Component {

    reportBloc = new ReportBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            optionSignatureOfficer : [
                { label: "Kepala Biro Umum", value: "Kepala Biro Umum" },
                { label: "Sekretariat Utama", value: "Sekretariat Utama" },
                { label: "Atas Nama", value: "Atas Nama" }
            ],
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.reportDetail?.employee_wfh_detail_uuid,
                nip: this.props.nip,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        // await this.reportBloc.fetchReport(this.state.dataForm)
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.reportBloc.fetchReport(dataForm)
        // if (this.props.uuid === '') {
        //     await this.createBloc.fetchCreate(this.state.dataForm)
        // } else {
        //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
        // }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.reportBloc.reportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    //this.props.setUuid(result.data.response.employee_transfer_uuid)
                    //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.props.toggle()
                    this.props.handleReload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    this.props.toggle()
                    break
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Input Laporan WFH</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <Row className="mb-3">
                                <label
                                    htmlFor="no_sk"
                                    className="col-md-4 col-form-label"
                                >
                                Deskripsi Pekerjaan Saat WFH <span className="text-danger">*</span>
                                </label>
                                <Col md="8">
                                    {(this.props.reportDetail?.employee_wfh_detail_status==2)?
                                    <AvField
                                        name="employee_wfh_detail_report"
                                        id="employee_wfh_detail_report"
                                        placeholder="Deskripsi Pekerjaan Saat WFH"
                                        type="textarea"
                                        errorMessage="Masukan Deskripsi Pekerjaan Saat WFH"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        value={this.props.reportDetail?.employee_wfh_detail_report}
                                        rows={10}
                                        readonly="readonly"
                                    />
                                    :
                                    <AvField
                                        name="employee_wfh_detail_report"
                                        id="employee_wfh_detail_report"
                                        placeholder="Deskripsi Pekerjaan Saat WFH"
                                        type="textarea"
                                        errorMessage="Masukan Deskripsi Pekerjaan Saat WFH"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        value={this.props.reportDetail?.employee_wfh_detail_report}
                                        rows={10}
                                    />
                                    }
                                </Col>
                            </Row>  

                            {/* <Row className="mb-3">
                                <label
                                    className="col-md-4 col-form-label"
                                >
                                    Upload File Pendukung 
                                </label>
                                <Col md="6">
                                    <FileInput
                                        name="file"
                                        placeholder="Upload File Pendukung"
                                        className="form-control"
                                        col="6"
                                    />
                                    <div className="mt-2">
                                        {
                                            this.props.reportDetail?.document_report != null ?  
                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.props.reportDetail.document_report?.documents_path}>
                                                    Download File <i className="fa fa-download ms-1"></i>
                                                </a>
                                            : ' '
                                        }
                                    </div>
                                </Col>
                            </Row> */}

                        
                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                                {(this.props.reportDetail?.employee_wfh_detail_status==2)?'':
                                <Button color="primary" type="submit">Submit dan Ajukan</Button>
                                }
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}

export default withRouter(ReportModal)